module.exports = __webpack_public_path__ + "4ccdf974a7a815599b93ce93fa43fa77.png";